module.exports = __webpack_public_path__ + "gold-bg-51862aa6887d2e69cc005e254378e74b.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/image_generator/gold-bg.jpg
// module id = 101
// module chunks = 0 1